import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons'
import reaLogo from '../assets/images/rea-logo.png'
import { scrollToSection } from '../utils/scrollToSection'
import '../pages/Footer.css'

const FOOTER_LINK_COLUMNS = [
    [
        { label: 'Home', targetId: 'homePage' },
        { label: 'Our Expertise', targetId: 'ourexperties', offset: 70 },
        { label: 'About us', targetId: 'aboutUs', offset: 120 },
        { label: 'FAQ', targetId: 'faq', offset: 90 },
    ],
    [
        { label: 'Contact us', targetId: 'contactUs', offset: 90 },
        { label: 'Our Mission', targetId: 'ourMission', offset: 90 },
        { label: 'Transformative impact', targetId: 'transformativeImpact', offset: 90 },
        { label: 'Our Differentiators', targetId: 'ourDiffer', offset: 90 },
    ],
]

function Footer() {
    return (
        <Container fluid className='siteFooter'>
            <Row>
                <Col md={5} className='mb-4 mb-md-0'>
                    <div className='footerBrand'>
                        <Image src={reaLogo} className='footerLogo' alt='Resolution Experts Alliance Association' />
                        <div className='footerBrandText'>
                            <div className='footerBrandTitle'>Resolution</div>
                            <div className='footerBrandSubtitle'>Experts Alliance Association</div>
                        </div>
                    </div>

                    <div className='footerContact'>
                        <div className='footerContactItem'>
                            <FontAwesomeIcon icon={faEnvelope} className='footerContactIcon' />
                            <span>info@resolutionexperts.in</span>
                        </div>
                        <div className='footerContactItem'>
                            <FontAwesomeIcon icon={faLocationDot} className='footerContactIcon' />
                            <span>H-2, Ranjeet Studio, Dada Saheb Phalke Road,<br />Dadar East, Mumbai - 400014</span>
                        </div>
                    </div>
                </Col>

                <Col md={7}>
                    <h3 className='footerLinksHeading'>Quick Links</h3>
                    <Row>
                        {FOOTER_LINK_COLUMNS.map((links, columnIndex) => (
                            <Col xs={12} sm={6} md={4} key={columnIndex}>
                                <ul className='footerLinksList'>
                                    {links.map(({ label, targetId, offset }) => (
                                        <li key={targetId}>
                                            <a href={`#${targetId}`} onClick={scrollToSection(targetId, offset)}>
                                                {label}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

export default Footer
